// style
import "./less/app.less";
import "material-design-iconic-font/dist/css/material-design-iconic-font.min.css";
import "angular-toastr/dist/angular-toastr.min.css";
import "angular-hotkeys/build/hotkeys.css";
import "ui-select/dist/select.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "index.less";
import "choices.js/assets/styles/css/choices.min.css";

// npm
import "core-js";
import "regenerator-runtime/runtime";
import * as angular from "angular";

import angularToastr from "angular-toastr";
import uiSelect from "ui-select";
import focusIf from "ng-focus-if";
import uibs from "angular-ui-bootstrap";
import "@iamadamjowett/angular-click-outside";

import "angular-data-grid/dist/dataGrid.min.js";
import "angular-data-grid/dist/pagination.min.js";
import "angular-promise-tracker";
import "angular-base64/angular-base64.min.js";

import "object-assign-shim";
import "angular-schema-form";
import "angular-schema-form-bootstrap";
import "angular-json-tree";
import "angular-messages";
import clipboard from "angular-clipboard";
import "angular-sanitize";

import "./utils";

import layout from "./layout/index.js";

// config
import config from "./config/index.js";

import behaviors from "./behaviors/index.js";
import components from "./components/index.js";
import extensions from "./extensions/json-schema/index.js";
import filters from "./filters/index.js";
import screens from "./screens/screens.js";
import services from "./services/index.js";

import bootstrapper from "./bootstrapper.ts";

const deps = [
	"ajoslin.promise-tracker",
	"dataGrid",
	"pagination",
	"base64",
	uibs,
	angularToastr,
	uiSelect,
	focusIf,
	layout,
	config,
	services,
	extensions,
	screens,
	components,
	behaviors,
	filters,
	"angular-click-outside",
	"ngSanitize",
	"schemaForm",
	"angular-json-tree",
	clipboard.name
];

angular.module("vesl", deps).run(bootstrapper);

angular.bootstrap(document, ["vesl"]);